
import { Component, Vue } from 'vue-property-decorator'
import eventBus from '@/plugins/eventBus'
import { getParameter } from '@/plugins/globals'
import MainHeaderCategory from '@/components/MainHeaderCategory.vue'
import { envConfiguration } from '@/plugins/globalStaticDatas'
@Component({
  components: { MainHeaderCategory },
})
export default class SearchHeader extends Vue {
  onHome: boolean = this.$route == undefined
  searchString: string = ''
  sectorId: any
  envConfigurations: any = envConfiguration
  searchTimeout = null
  searchOnKeyUp($event: any) {
    clearTimeout(this.searchTimeout)
    this.searchTimeout = setTimeout(() => {
      eventBus.$emit('search:changed-value', this.searchString)
    }, 500)
    if ($event.keyCode === 13 || $event.type === 'click') {
      if (window.location.pathname.indexOf('catalog.html') < 0) {
        window.location.href = `/catalog?sector_id=${this.sectorId}&qs=${this.searchString}`
      }
    }
  }

  mounted() {
    console.log(this.$route)
    this.sectorId = getParameter('sector_id') || this.envConfigurations.sectorID
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    let qs = urlParams.get('qs')
    if (qs && qs !== '') {
      this.searchString = qs
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        eventBus.$emit('search:changed-value', this.searchString)
      }, 500)
    }
  }
}
